import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useRemoveCustomerSchema = () => {
  const { t } = useTranslation();

  return z.object({
    agreed: z.literal(true, {
      errorMap: () => ({
        message: t("removeCustomerModal.form.fields.agreed.errors.required"),
      }),
    }),
    customerStateChangingReasonId: z.number({
      required_error: t(
        "removeCustomerModal.form.fields.reasonId.errors.required",
      ),
    }),
    comment: z.optional(z.string()),
  });
};
